import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { nodeToDOM } from '@common/util/schema';
import { NodeSpec } from 'prosemirror-model';

export class MadCapPageFooterSchemaPlugin extends SchemaPlugin {
  nodes = {
    madcappagefooter: {
      group: 'block',
      content: 'block+',
      defining: true, // Persist and wrap the inserted content during replace operations
      fillIfContentDeleted: 'mcCentralContainer',
      parseDOM: [{
        tag: 'MadCap\\:pageFooter'
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:pageFooter'
    }
  } satisfies Record<string, NodeSpec>;
}
